import { createFileRoute } from '@tanstack/react-router'

import { PaymentsPage } from '@/pages/payments-page'
import { PaymentsSearchSchema } from '@/pages/payments-page/model/payments-search'

export const Route = createFileRoute('/_dashboard-layout/payments')({
    component: PaymentsPage,
    validateSearch: PaymentsSearchSchema,
})
